import Vue from 'vue';
import { create } from 'vue-modal-dialogs';
import confirmUI from '@/components/dialog/confirm';

const dialogAPI = {
	install(Vue) {
		Vue.prototype.$dialog = {
			confirm: create(confirmUI),
		};
	},
};

Vue.use(dialogAPI);
